import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";

import Table from './Table';
import CardStatus from "./CardStatus";
import Progress from "./Progress";
import List from "./List";
import NavTags from "./NavTags";
import CardList from "./CardList";
import MdcSlider from './MdcSlider';
import Input from './Input';
import ProjectPreviewer from "./ProjectPreviewer";

export default (editor, opt = {}) => {
  GpParser.loadFromList(
    [
      Table,
      MdcSlider,
      CardStatus,
      Progress,
      List,
      ProjectPreviewer,
      CardList,
      NavTags,
      Input
    ],
    CATEGORIES.INVISIBLE,
    editor,
    opt
  );
};
